import { Controller, useFormContext } from 'react-hook-form';
import { Typography } from '@shinetools/sunshine-universal';

import { ShineRecurringAccountingExportSettingsType } from '__generated__/GQL';
import SunshineCard from 'components/_core/SunshineCard';

import { AccountingExportSchema } from '../../accountingExport.schema';
import locales from './locales';

export const TypeCards = () => {
  const { control } = useFormContext<AccountingExportSchema>();

  return (
    <Controller
      control={control}
      name="type"
      render={({ field: { onChange, value } }) => (
        <SunshineCard.RadioGroup
          direction="row"
          onChange={onChange}
          value={value}
        >
          {/**
           * @todo Add value for creating one-off exports
           * @see https://linear.app/shine/issue/CAC-1051
           */}
          <SunshineCard
            title={locales.oneOff.title}
            value="placeholder"
            variant="radio"
          >
            <Typography.Text variant="secondary">
              {locales.oneOff.description}
            </Typography.Text>
          </SunshineCard>

          <SunshineCard
            isActive={
              value ===
              ShineRecurringAccountingExportSettingsType.ShineRecurring
            }
            title={locales.recurring.title}
            value={ShineRecurringAccountingExportSettingsType.ShineRecurring}
            variant="radio"
          >
            <Typography.Text variant="secondary">
              {locales.recurring.description}
            </Typography.Text>
          </SunshineCard>
        </SunshineCard.RadioGroup>
      )}
    />
  );
};
